import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { LoginModal } from '../../Components/Modals/LoginModal/LoginModal';
import { useLocation, useNavigate } from 'react-router';
import { isType } from '../../shared';
import Spinner from '../../Components/Spinner/Spinner';
import { selectIsLoggedIn } from '../../redux/account';
import { ArgumentReponse, ReportArgumentResponse, fetchReportArguments } from './models';

function ResultReport(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loginIsOpen, setLoginIsOpen] = useState<boolean>(false);

  const isLoggedIn = useSelector(selectIsLoggedIn);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [reportArgument, setReportArguments] = useState<ReportArgumentResponse|null>(null);
  const [isLoginRequired, setLoginRequired] = useState<boolean>(false);
  const [ reportArgumentURL, setReportArgumentURL ] = useState<string>('');

  if (searchParams) {
    const path = location.pathname;
    const search = location.search;
    const url = 'http://poseidonaws.ets-naepanalysis-prod.c.ets.org/nqt'+`${path}`+`${search}`;

    if (!reportArgumentURL) {
      setReportArgumentURL(url);
    }

  }


  useEffect(() => {

    if (searchParams) {
      setIsLoading(true);
      const processReportArgument = async() => {
        const response = await fetchReportArguments(reportArgumentURL);

        if (isType<ReportArgumentResponse>(response, 'ReportArgumentResponse')) {
          const results = response.reports;
          const asArray = Object.entries(results);
          const isLoginRequirement = asArray[2][1];
          if ( isLoginRequirement ){
            setLoginRequired(true);
          } else {
            setLoginRequired(false);
          }
          setReportArguments(response);
          setIsLoading(false);
        }
      };
      processReportArgument();

    } else {
      setSearchParams({});
    }
  }, [searchParams, setSearchParams, reportArgumentURL]);

  useEffect(() => {

    if (!isLoading && reportArgument) {
      const argumentResponseState = reportArgument as ReportArgumentResponse;
      const argumentResState = argumentResponseState.reports as ArgumentReponse;
      const argumentAdminID = Number(argumentResState.AdminID);

      if (isLoggedIn === true && isLoginRequired) {
        navigate('/testresults', {state: {administrationID: argumentAdminID, isLoginRequired: true}});
      } else {
        if (isLoginRequired && isLoggedIn === false) {
          if (isLoading === false ){
            setLoginIsOpen(true);
            document.body.classList.add('bg-noscroll');
          }
        } else {
          const state = {administrationID: 1, isLoginRequired: false };
          navigate('/testresults', {state});
        }
      }

    }
  }, [isLoading, reportArgument, isLoggedIn, isLoginRequired, navigate]);

  return (
    <main className='nqt-test-results'>
      <section className='nqt-tr--header'>

      </section>
      <section className='nqt-tr--selectors-container'>
        {
          isLoading && <Spinner size={80}/>
        }
        <div>
          {
            isLoading === false &&
            <>
              <LoginModal open={loginIsOpen} onClose={() => setLoginIsOpen(false) }  />
            </>
          }
        </div>
      </section>


    </main>
  );
}

export default ResultReport;